module.exports = __webpack_public_path__ + "media/images/svg/logo_la_solea_bio-0780ada076fc5d5498f6898f70980059.svg";